WB.DataManagers = WB.DataManagers || {};
WB.DataManagers.Metadata = function ($location, $route, $q, _Metadata, Metadata, _User, MetadataDataService, DataManagerUtility, _Config) {

    //
    // Metadata for a URL returns the current context for that URL on the server,
    // including the active location.
    //
    // This means that the signature needs to include the right active location,
    // otherwise the returned metadata from cache could include the wrong active location.
    //

    var signature = function() {
        let sig = $location.path() + ',' + _User?.ActiveLocation?.Locality?.SlugName;
        const { station, camera, cam, latlng, center, layerId, index, category, title } = $route?.current?.params ?? {};
        if (station) {
            sig += ':' + station;
        }
        if (camera) {
            sig += ':' + camera;
        }
        if (latlng) {
            sig += ':' + latlng;
        }
        if (cam) {
            sig += ':' + cam;
        }
        if (layerId && center) {
            sig = `${sig}:${center}:${layerId}`;
        }
        if ($location.path() === '/life/snow-ski/' && center) {
            sig = `${sig}:${center}`;
        }
        if (center && Number.isInteger(parseInt(index))) {
            sig = `${sig}:${center}:${index}`;
        } if (category && title && $location.path().startsWith('/weather-videos') && _User?.ActiveLocation?.Locality?.SlugName) {
            sig = `${sig}:${_User?.ActiveLocation?.Locality?.SlugName}`;
        }
        return sig;
    };

    this.init = function() {
        DataManagerUtility.SetCache({
            name: 'Metadata',
            signature: signature(),
            value: $q(function(resolve, reject) {
                resolve(_Metadata);
            }),
            expiryKey: 'Metadata'

        });
        Metadata.set(_Metadata);
    };

    this.GetMetadataForUrl = function(url) {
        const currentPagePath = $location.url();
        const { station, cam, latlng, location, id, center, category, title } =  $route?.current?.params ?? {};
        var resolver = DataManagerUtility.GetCache({
            name: 'Metadata',
            signature: signature()
        });

        /**
         * // cache hit (if user have visited /news/ , /photo/, /story/, /video/ pages), we don't change locations, so this will always return the 
         * // last active location the user had before first visiting this page.
         */
        if (resolver) {
            return resolver;
        } else {
            let metaUrl = url;
            // we addressed location bug issues on web 1 by modifying the metaUrl, with the press page migrated to Web 2, we no longer need this. 
            const shouldEnableWeb1LocationBugFixOnPress = currentPagePath?.startsWith('/press') && _Config?.EnableWeb2;

            /**
             * url is almost always === undefined,
             * MetadataDataService.GetMetadataForUrl(url) would use the current page path when trying to retrieve metadata values i.e url = url || $location.url();
             * For every path that has no params, and a given active location, massage the path so we can get new meta for it and cache it correctly.
             */
            if (!location
                && !id
                && !latlng
                && !cam
                && !station
                && currentPagePath
                && !currentPagePath?.startsWith('/sitemap')
                && !currentPagePath?.startsWith('/life/snow-ski-detail')
                && !shouldEnableWeb1LocationBugFixOnPress
                && _User?.ActiveLocation?.Id) {
                if (currentPagePath?.startsWith('/weather-videos') && category && title) {
                    const { Latitude, Longitude } = _User?.ActiveLocation?.Locality || {};
                    metaUrl = `/weather-videos/${category}/${title}?loc_lat=${Latitude}&loc_lon=${Longitude}`;
                } else if (currentPagePath?.startsWith('/life/snow-ski') && center) {
                    metaUrl = `/life/snow-ski/${_User?.ActiveLocation?.Locality?.SlugName}?center=${center}`;
                } else {
                    metaUrl = currentPagePath.endsWith('/') ? `${currentPagePath}${_User?.ActiveLocation?.Locality?.SlugName}` : `${currentPagePath}/${_User?.ActiveLocation?.Locality?.SlugName}`;
                }

            }
            
            var newCache = {
                name: 'Metadata',
                signature: signature(),
                value: MetadataDataService.GetMetadataForUrl(metaUrl),
                expiryKey: 'Metadata'
            };
            DataManagerUtility.SetCache(newCache);
            newCache.value.catch(function(err) {
                DataManagerUtility.ClearCache({ name: 'Metadata', signature: signature() });
            });
            return newCache.value;
        }
    };

};
WB.DataManagers.Metadata.$inject = ['$location', '$route', '$q', '_Metadata', 'Metadata', '_User', 'MetadataDataService', 'DataManagerUtility', '_Config'];

WB.Core.service('MetadataDataManager', WB.DataManagers.Metadata);
